export const MAX_DISP_NUM = 3;
export const BUTTON_SIZE = "1.42rem";
